var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-items-list',{attrs:{"content-type":"trial-playlists","content-type-singular":"trial-playlist","content-name":"Trial Playlists","content-name-singular":"Trial Playlist"}})}
var staticRenderFns = []

export { render, staticRenderFns }